
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 19 23","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.375 17.125h2.25v-6.75h-2.25v6.75zm1.125-9c.319 0 .586-.108.802-.324.215-.215.323-.482.323-.801 0-.319-.108-.586-.323-.802a1.091 1.091 0 00-.802-.323c-.319 0-.586.108-.801.323A1.09 1.09 0 008.375 7c0 .319.108.586.324.801.215.216.482.324.801.324zm0 14.625c-2.606-.656-4.758-2.152-6.454-4.486C1.349 15.93.5 13.338.5 10.488V3.625L9.5.25l9 3.375v6.863c0 2.85-.848 5.442-2.545 7.776-1.697 2.334-3.849 3.83-6.455 4.486z"}})])
          )
        }
      }
    